import React, { useState } from 'react';

const tierConfig = {
    HOT: { bg: 'bg-red-100', text: 'text-red-800', border: 'border-red-200', dot: 'bg-red-500' },
    WARM: { bg: 'bg-amber-100', text: 'text-amber-800', border: 'border-amber-200', dot: 'bg-amber-500' },
    COLD: { bg: 'bg-slate-100', text: 'text-slate-600', border: 'border-slate-200', dot: 'bg-slate-400' }
};

export default function ScoreBadge({ intelligence, label }) {
    const [showReasons, setShowReasons] = useState(false);

    if (!intelligence) return null;

    const { score, tier, reasons = [] } = intelligence;
    const config = tierConfig[tier] || tierConfig.COLD;

    return (
        <div className="relative inline-block">
            <button
                type="button"
                onClick={(e) => { e.stopPropagation(); setShowReasons(!showReasons); }}
                onMouseEnter={() => setShowReasons(true)}
                onMouseLeave={() => setShowReasons(false)}
                className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-semibold border cursor-help transition-colors ${config.bg} ${config.text} ${config.border}`}
            >
                <span className={`w-1.5 h-1.5 rounded-full ${config.dot}`}></span>
                {score}
                <span className="opacity-70 text-[10px] uppercase">{tier}</span>
            </button>

            {showReasons && reasons.length > 0 && (
                <div
                    className="absolute z-50 bottom-full left-1/2 -translate-x-1/2 mb-2 w-64 bg-white rounded-lg shadow-xl border p-3 text-xs"
                    onClick={e => e.stopPropagation()}
                >
                    {label && <p className="font-bold text-gray-700 mb-2 uppercase tracking-wider text-[10px]">{label} Score Factors</p>}
                    <div className="space-y-1.5">
                        {reasons.map((r, i) => (
                            <div key={i} className="flex items-start justify-between gap-2">
                                <span className="text-gray-600 leading-tight">{r.description.replace('Unknown', 'Awaiting Data')}</span>
                                <span className={`font-bold tabular-nums whitespace-nowrap ${r.points >= 0 ? 'text-green-700' : 'text-red-600'}`}>
                                    {r.points >= 0 ? '+' : ''}{r.points}
                                </span>
                            </div>
                        ))}
                    </div>
                    <div className="mt-2 pt-2 border-t flex justify-between items-center">
                        <span className="text-gray-400">Total</span>
                        <span className="font-bold text-gray-900">{score}/100</span>
                    </div>
                    <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 rotate-45 w-2 h-2 bg-white border-r border-b"></div>
                </div>
            )}
        </div>
    );
}
